import React from 'react';
import { useTranslation } from 'react-i18next';
import { customStorage } from '../services/CommonService';
import './LanguageToggle.scss';

const LanguageToggle = () => {
  const { i18n } = useTranslation();

  const languages = i18n.options.supportedLngs?.filter(lng => lng !== 'cimode') || ['en', 'mm'];
  const currentIndex = languages.indexOf(i18n.language);

  const handleToggle = () => {
    const nextIndex = (currentIndex + 1) % languages.length;
    const nextLang = languages[nextIndex];
    i18n.changeLanguage(nextLang);
    customStorage.setItem('i18nextLng', nextLang);
  };

  const getLabel = (lng) => {
    return lng.toUpperCase();
  };

  return (
    <div className="language-toggle-wrapper" onClick={handleToggle}>
      <div className="language-toggle">
        <div
          className="toggle-slider"
          style={{
            transform: `translateX(${currentIndex * 100}%)`,
          }}
        />
        {languages.map((lng) => (
          <span
            key={lng}
            className={`toggle-label${i18n.language === lng ? ' active' : ''}`}
          >
            {getLabel(lng)}
          </span>
        ))}
      </div>
    </div>
  );
};

export default LanguageToggle;
